import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Box, Container, FormControl, Grid, IconButton, List, ListItem, ListItemText, Paper, TextField } from '@mui/material';
import { Modal } from "react-bootstrap";
import './Chat.css';
import SendIcon from "@mui/icons-material/Send"
import io from 'socket.io-client';
import chatService from '../Services/chat.service';
import { useSelector } from 'react-redux';

const Chat = ({ isOpen, closeChatModal, comparedBids, UserCapName }) => {
  const [current_user, setUser] = useState(UserCapName ? UserCapName?.fromUser : comparedBids?.sourceCapacity?.capacityName);
  const socket = useRef(null);
  const [chatMessages, setChatMessages] = useState([]);
  const [chatMessage, setChatMessage] = useState('');
  const role = useSelector(state => state?.sessionState?.role)
  const currentRoute = window.location.pathname;

  const fromUser = UserCapName ? UserCapName?.fromUser : comparedBids?.sourceCapacity?.capacityName;
  const toUser = UserCapName ? UserCapName?.toUser : comparedBids?.bidCapacity?.capacityName;

  const messagesRef = useRef(null)

  const scrollToBottom = () => {
    messagesRef.current?.scrollIntoView({ behavior: "smooth" })
  }

  useEffect(() => {
    scrollToBottom()
  }, [chatMessages]);

  useEffect(() => {
    // Listen for incoming messages
    // setUser("test_user" + Date.parse(new Date()));
    try {
      socket.current = io('https://chat.gna.energy'); // Replace with your server URL
    } catch (err) {
      console.log('socketError: ', err)
    }
    try {
      socket.current.on('connect', () => {
        socket.current.emit('userDetails', { fromUser, toUser });
        console.log('Connected Successfully')
      })
    } catch (err) {
      console.log("ConnectionError: ", err)
    }

    socket.current.on('message', (message) => {
      setChatMessages((prevMessages) => [...prevMessages, message]);
    });

    socket.current.on('output', (message) => {
      setChatMessages(message);
    });

  //   socket.current.on('disconnect', (e) => {
  //           console.log("UserWent offline...",e);
  // });
    return () => {
      try {
        socket.current.disconnect(() => { });
        console.log('Disconnected Successfully')
      } catch (err) {
        console.log('DisconnectedError : ', err)
      }
    };
  }, []);

  const listChatMessages = chatMessages.map((chatMessageDto, index) =>
    <ListItem key={index} className={`message-wrapper ${current_user === chatMessageDto.from ? 'self-message' : 'others-message'}`}>
      <ListItemText>
        <Paper className={`user-msg ${current_user === chatMessageDto.from ? 'self' : 'others'}`}>
          <Grid xs={10} container ref={messagesRef}>
            <Grid xs={12} className="user-name" item>{chatMessageDto.from}:</Grid>
            <Grid xs={12} item>{chatMessageDto.message}</Grid>
          </Grid>
        </Paper>
      </ListItemText>
    </ListItem>
  );
  const sendMessage = () => {

    // socket.current.emit('chat message', {user: current_user, message: chatMessage});
    // setChatMessage('');
    if (chatMessage.trim()) {
      let final = {
        'fromUser': fromUser,
        'toUser': toUser,
        'msg': chatMessage
      };
      let reqBody = {
        "senderCapacityName": fromUser,
        "receiverCapacityName": toUser,
        "receivedMessage": chatMessage,
        "specificationType": role
      }
      socket.current.emit('chatMessage', final);
      chatService.sendChatNotification(reqBody).then((response)=>{
        if(response?.data?.code === 200){
        }
      }).catch(err=>console.log("Api Error :",err))
      setChatMessage('');
    }
  }
  return (
    <Modal show={Boolean(isOpen)} onHide={closeChatModal} centered >
      <Modal.Header closeButton>
        <Modal.Title>Conversation</Modal.Title>
      </Modal.Header>
      <Modal.Body className="m-3">
        <Fragment>
          <Container >
            <Paper>
              <Box p={3}>
                <Grid container spacing={4} alignItems="center">
                  <Grid id="chat-window" xs={12} item>
                    <List id="chat-window-messages" className='table-scrollY'>
                      {listChatMessages}
                    </List>
                  </Grid>
                  {currentRoute !== '/capacity_listing' &&<Grid xs={10} item>
                    <FormControl fullWidth>
                      <TextField
                        value={chatMessage}
                        label="Type your message..."
                        variant="outlined"
                        onChange={(e) => {
                          setChatMessage(e.target.value);
                        }}
                        onKeyDown={(e) => {
                          if (e.keyCode === 13) {
                            sendMessage();
                          }
                        }}
                        disabled={currentRoute === '/capacity_listing' ? true : false}
                      />
                    </FormControl>
                  </Grid>}
                  {currentRoute !== '/capacity_listing' &&<Grid xs={1} item>
                    <IconButton aria-label="send" color="primary" onClick={sendMessage}>
                      <SendIcon className="custom-send-icon"></SendIcon>
                      {/* <SendIcon style={{ color: 'red' }} /> */}
                    </IconButton>
                  </Grid>}
                </Grid>
              </Box>
            </Paper>
          </Container>
        </Fragment>
      </Modal.Body>
    </Modal>
  );
}

export default Chat;
